import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_mobile-footer_desktopapp_store_badge_hover-action_unknown';
/**
 * Event when user hovers on app store download badge
 */
export function trackRetailerMobileFooterDesktopappStoreBadgeHover() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
